import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-42c5a144"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "animate"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_5 = { class: "search-form" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "spacer" }, null, -1))
const _hoisted_7 = { class: "table-container" }
const _hoisted_8 = { class: "modern-table" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Lenguaje"),
    /*#__PURE__*/_createElementVNode("th", null, "Seleccionar")
  ])
], -1))

import DefaultLayout from '@/layouts/DefaultLayout.vue'
import ForumService from '@/services/ForumService'
import { onMounted, ref,Ref } from 'vue';
import main from '@/data/main.js';
import ForumI from '@/interfaces/ForumInterface';
//import useWindowWidth from '@/composables/useWindowWidth';
//import AdvertisementMain from '@/components/advertisement/AdevertisementMain.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ForumGeneralView',
  setup(__props) {

const service = new ForumService()
const items:Ref<ForumI[]> = ref([])
const filtered:Ref<ForumI[]>  = ref([])
const loading = ref(false)
const search = ref('')
//const {windowWidth} = useWindowWidth()
//const tableSmall= ref(850);

onMounted(async () => {
    loading.value = true
    items.value = await service.GetAllTopics()
    filtered.value = items.value
    loading.value = false
})

const handleSearch = () => {
    loading.value = true
    filtered.value = items.value.filter(item => item.name?.toLowerCase().includes(search.value.toLowerCase()))
    loading.value = false
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(DefaultLayout, null, {
    default: _withCtx(() => [
      (loading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_v_icon, {
              name: "ri-loader-2-fill",
              animation: "spin",
              class: "icon"
            })
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("h1", null, _toDisplayString(_unref(main).TITLE_FORUM_GENERAL_VIEW), 1),
            _createVNode(_component_RouterLink, {
              to: {name:'forum'},
              class: "breadcrumbs"
            }, {
              default: _withCtx(() => [
                _createTextVNode("Dudas y Preguntas")
              ]),
              _: 1
            }),
            _createTextVNode(" / General "),
            _hoisted_3,
            _createElementVNode("p", null, _toDisplayString(_unref(main).SUBTITLE_FORUM_GENERAL_VIEW), 1),
            _hoisted_4,
            _createElementVNode("form", _hoisted_5, [
              _createVNode(_component_v_icon, { name: "fa-filter" }),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
                placeholder: "Escribe aquí para filtrar.",
                onKeyup: handleSearch,
                class: "input-job"
              }, null, 544), [
                [_vModelText, search.value]
              ])
            ]),
            _hoisted_6,
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("table", _hoisted_8, [
                _hoisted_9,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filtered.value, (item) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: item.id
                    }, [
                      _createElementVNode("td", null, _toDisplayString(item.name), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_RouterLink, {
                          to: { name: 'forum-general-list', params: { topic_id: item.id, topic_name: item.name} }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, {
                              name: "md-fileopen-round",
                              class: "ver",
                              fill: _unref(main).THIRD_COLOR,
                              scale: "2"
                            }, null, 8, ["fill"])
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]))
    ]),
    _: 1
  }))
}
}

})